


import { useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {
  __experimentalHStack as HStack,
  __experimentalText as Text,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  Button,
  Popover,
} from '@wordpress/components';
import { lock } from '@wordpress/icons';

export const IconPicker = ({ Icon, onIconSelect }) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState();
  const [selectedIcon, setSelectedIcon] = useState(Icon);

  // Ensure state syncs with prop if `Icon` changes
  useEffect(() => {
    setSelectedIcon(Icon || 'none');
  }, [Icon]);

  const togglePopover = () => {
    setIsPopoverVisible((prev) => !prev);
  };

  const handleIconClick = (icon) => {
    setSelectedIcon(icon);
    onIconSelect(icon); // Update parent with selected icon
    setIsPopoverVisible(false); // Close the popover after selecting
  };

  const arrowMap = {
    'type-1': { left: '←', right: '→' },
    'type-2': { left: '⇦', right: '⇨' },
    'type-3': { left: '⇐', right: '⇒' },
    'type-4': { left: '⟵', right: '⟶' },
    'type-5': { left: '🡐', right: '🡒' },
    'type-6': { left: '🡄', right: '🡆' },
    'type-7': { left: '⇜', right: '⇝' },
    'type-8': { left: '⇠', right: '⇢' },
    'type-9': { left: '➤', right: '➥' },
    'type-10': { left: '🡸', right: '🡺' },
    'type-11': { left: '⏴', right: '⏵' },
    'type-12': { left: '⮜', right: '⮞' },
    'type-13': { left: '↚', right: '↛' },
    'type-14': { left: '⇷', right: '⇸' },
    'type-15': { left: '🢐', right: '🢒' },
    'type-16': { left: '🢔', right: '🢖' },
    'type-17': { left: '🢘', right: '🢚' },
    'type-18': { left: '⇚', right: '⇛' },
  };

  const iconOptions = [
    { label: __('Default', 'vayu-blocks'), value: 'none', icon: lock },
    ...Object.entries(arrowMap).map(([key, { left, right }], index) => ({
      label: `${__('Type', 'vayu-blocks')} ${index + 1}`,
      value: key,
      icon: `${left} ${right}`, // Save the arrow as a string
      extraClass: index + 1 > 5 ? 'vb-icon-size-type-6' : '', // apply class for type 7+
    })),
  ];

  const selectedOption = iconOptions.find((option) => option.value === selectedIcon);
  const iconDisplay = selectedOption ? selectedOption.icon : lock;

  return (
    <div className="vayu_blocks_icon_picker_panel vb-new-slider-icon-picker">
      <ToolsPanel label={__('Button Icon')} className="vayu_blocks_icon_picker_name">
        <ToolsPanelItem
          label={__('Icon')}
          hasValue={() => !!selectedIcon}
          onDeselect={() => handleIconClick(null)}
          isShownByDefault
        >
          <Button
            ref={setPopoverAnchor}
            onClick={togglePopover}
            className={`block-editor-panel-icon-settings__dropdown ${
              isPopoverVisible ? 'is-open' : ''
            }`}
          >
            <HStack alignment="left">
              {selectedOption?.value === 'none' ? (
                    <>
                        <div className="vayu-blocks-panel-ihover vayu-blocks-none-button vb-none-icon-picker vb-display-tools-none"></div>
                        <Text>{selectedOption ? selectedOption.label : __('None', 'vayu-blocks')}</Text>
                    </>
              ) : (
                    <>
                        <Text>{selectedOption ? selectedOption.label : __('None', 'vayu-blocks')}</Text>
                        <span className="vb-display-tools-other icon-display vb-icon-display-important">
                            {iconDisplay}
                        </span>
                    </>
              )}
         
            </HStack>
          </Button>
        </ToolsPanelItem>
      </ToolsPanel>

      {isPopoverVisible && (
        <Popover
          placement="left-start"
          className="vayu_blocks_toolspanel_items_popover"
          anchor={popoverAnchor}
          onClose={() => setIsPopoverVisible(false)}
          offset={35}
          resize
        >
          <div className="vayu_blocks_icon_picker vb-icon-picker-slider">
            <h4>{__('Select Icon')}</h4>
            <p>{__('Choose an icon for your element or select "Default".')}</p>
            <div className="vayu-blocks-icon-picker-grid">
              {iconOptions.map((option) => {
                return (
                  <div
                    key={option.value}
                    className={`vayu_blocks-icon-option ${
                      selectedIcon === option.value ? 'selected' : ''
                    }`}
                    onClick={() => handleIconClick(option.value)}
                    title={option.label}
                  >
                    {option.value === 'none' ? (
                      <div className="vayu-blocks-panel-ihover vayu-blocks-none-button vb-none-icon-picker"></div>
                    ) : (
                      <span className={`icon-display vb-icon-display-size ${option.extraClass || ''}`}>{option.icon}</span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
};